module.exports = __webpack_public_path__ + "static/media/awave-logotyp.e8018d1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/awave-logotyp.svg
// module id = 1636
// module chunks = 27